<script lang="ts">
    import { faAngleLeft, faEdit, faPlus, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    import { get_current_component, onMount } from 'svelte/internal'
    import { AudiencesService } from '../../modules/eventsApi/audiences/audiences.service'
    import { AudiencesRepository } from '../../modules/eventsApi/audiences/audiences.repository'
    import type { Audience } from '../../modules/eventsApi/audiences/audience'
    import Content from '../_common/content.svelte'
    import DadosEventos from '../account/events/event-log.svelte'
    import Popover from '../_common/popover.svelte'
    import AutomacaoManagerActs from './automacao-manager-acts.svelte'
    import { AutomationGroupsRepository } from '../../modules/automationApi/automation-groups/automation-groups.repository'
    import { AutomationGroupsService } from '../../modules/automationApi/automation-groups/automation-groups.service'
    import { AutomationGroup } from '../../modules/automationApi/automation-groups/automation-group'
    import type { CreateAutomationGroupsDto } from '../../modules/automationApi/automation-groups/dto/create-automation-groups.dto'
    import type { UpdateAutomationGroupsDto } from '../../modules/automationApi/automation-groups/dto/update-automation-groups.dto'
    import { AutomationSourceEnum } from '../../modules/automationApi/automations/automation-source.enum'
    import AutomacaoShow from './automacao-show.svelte'
    import AudienceManager from './audience/audience-manager.svelte'
    import AutomacaoAssistente from './automacao-assistente.svelte'
    import Zgrid from '../_common/z/zgrid.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine, GridToggle } from '../_common/z/zgrid'
    import type { User } from '../../modules/usersApi/users/user'
    import Zact from '../_common/z/zact.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZsheetSection from '../_common/z/sheet/zsheet-section.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'

    const rep = new AutomationGroupsRepository()
    const service = new AutomationGroupsService(rep)

    // ---

    let dynamicRepeat = 0
    let dynamicRepeatFactor = 0
    let childAct
    let childActAutomationId = null
    let showFactor = true
    let active = true

    const audienceR = new AudiencesRepository()
    const audienceS = new AudiencesService(audienceR)
    let audiences: Audience[] = []

    async function loadAudiences() {
        audiences = await audienceS.getAll()
    }

    function dinamicoOnChange() {
        if (dynamicRepeat === 0) {
            showFactor = false
            dynamicRepeatFactor = factors[0]
        } else if (dynamicRepeat >= 60) {
            showFactor = false
            dynamicRepeatFactor = factors[3]
        } else {
            showFactor = true
        }
    }

    const me = get_current_component()
    let show = false
    // 1 lista · 2 formulário (novo/edição) · 3 eventos do tipo · 4 contatados de um grupo ·
    // 5 assistente. Cada número tem um bloco {#if step === N} lá embaixo: reusar um já ocupado
    // faz os dois renderizarem juntos.
    let step = 1
    let entities: AutomationGroup[] = []
    let autGroup: AutomationGroup = new AutomationGroup()

    onMount(async () => {
        await loadAudiences()
        await loadEntities()
    })

    async function loadEntities() {
        try {
            show = true
            entities = []
            entities = await service.getAll()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        autGroup = new AutomationGroup()
        dynamicRepeat = 60
        dynamicRepeatFactor = 0
        childActAutomationId = null
        active = true
        dinamicoOnChange()
        step = 2
    }

    async function createEntity() {
        try {
            if (show) return
            show = true
            let repeat = (dynamicRepeat * dynamicRepeatFactor) / 1000
            const dto: CreateAutomationGroupsDto = {
                source: autGroup.source,
                audienceId: autGroup.audienceId,
                label: autGroup.label,
                repeat,
                status: active ? 100 : 70,
            }
            autGroup = await service.create(dto)
            window.api.users.statistics.tick('automation.save')
            //todo: event success
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function toggleStatus(automationGroupId: string) {
        const current = entities.find((el) => el.automationGroupId === automationGroupId)
        await service.update(automationGroupId, { status: current.status === 100 ? 70 : 100 })
        await loadEntities()
    }

    let hidePhone = location.href.includes('://127.') || location.href.includes('://support.')
    async function doubleCheckUser() {
        if (!location.href.includes('://support.')) return true
        const phone = prompt('Informe os 4 últimos dígitos do telefone do usuário para confirmar:')
        if (!phone) return false
        const users: User[] = await window.api.users.companies.getCompanyUsers(6000)
        const found = users.some((el) => el.phone.slice(-4) == phone.trim())
        if (!found) {
            window.alert('Confira se está logado na conta correta.')
            return false
        }

        return true
    }

    async function updateEntity() {
        try {
            if (show) return
            show = true
            let repeat = (dynamicRepeat * dynamicRepeatFactor) / 1000
            if (dynamicRepeat >= 60) {
                repeat = (dynamicRepeat * factors[factors.length - 1]) / 1000
            }
            const dto: UpdateAutomationGroupsDto = {
                audienceId: autGroup.audienceId,
                label: autGroup.label,
                repeat,
                status: active ? 100 : 70,
            }
            await service.update(autGroup.automationGroupId, dto)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (!(await doubleCheckUser())) return false
        if (autGroup.automationGroupId) {
            if (await childAct.saveEntity()) {
                updateEntity()
            }
        } else {
            createEntity()
        }
    }

    let loading = false
    let editing = false
    async function editEntity(id: string) {
        loading = true
        try {
            show = true
            editing = true
            autGroup = new AutomationGroup()
            autGroup = await service.getOne(id)
            active = autGroup.status === 100
            console.log('autGroup', autGroup)
            let { factor } = getDynamicDateFactor(autGroup.repeat * 1000, autGroup.repeat * 1000)
            dynamicRepeatFactor = factor
            dynamicRepeat = autGroup.repeat < 0 ? autGroup.repeat : (autGroup.repeat * 1000) / +dynamicRepeatFactor
            childActAutomationId = autGroup.automation.find((el) => el.parentAutomationId === null)?.automationId || null
            if (dynamicRepeat >= 60) {
                showFactor = false
            } else {
                showFactor = true
            }
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            loading = false
            show = false
            editing = false
        }
    }

    const factors = [3600000, 86400000, 2592000000, 31536000000]
    const factorsLabel = ['hora(s)', 'dia(s)', 'mes(es)', 'ano(s)']
    const factor_hour = 0
    const factor_day = 1
    const factor_month = 2
    const factor_year = 3
    const maxRepeat = 58
    function getDynamicDateFactor(dateFrom: number, dateTo: number) {
        const dateRef = Math.abs(dateFrom) > Math.abs(dateTo) ? dateFrom : dateTo
        const past = dateRef < 0 ? -1 : 1
        // hora, dia, mes, ano
        let pos = 0
        let factor = 0
        for (let index = 0; index < factors.length; index++) {
            const base = dateRef / (maxRepeat + 1)
            pos = index
            factor = factors[index]
            if (base < factors[index]) break
        }
        factor *= past
        let label = factorsLabel[pos]
        return { factor, label }
    }

    function showHistory() {
        step = 3
    }

    async function loadHistory() {}

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await service.remove(autGroup.automationGroupId)
            await loadEntities()
            step = 1
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        automationGroupId = null
        step = 1
    }

    // ---- assistente -------------------------------------------------------------------------
    // "Nova automação" abre uma escolha em vez de ir direto para um dos caminhos: quem chega
    // pela primeira vez não tem como saber o que "começar do zero" significa antes de ver o que
    // existe pronto.
    let _showCreateChoice = false

    function openCreateChoice() {
        _showCreateChoice = true
    }

    function chooseTemplate() {
        _showCreateChoice = false
        step = 5
    }

    function chooseManual() {
        _showCreateChoice = false
        newEntity()
    }

    // O assistente já criou público, grupo e ação. Só falta a mensagem, que é onde o formulário
    // de ações é bom — então caímos direto nele, com o grupo carregado.
    async function assistantCreated(event: CustomEvent) {
        const { automationGroupId: newGroupId, messageHint } = event.detail
        assistantHint = messageHint || ''
        await loadEntities()
        await editEntity(newGroupId)
    }

    let assistantHint = ''

    let _showAudience = false
    let audienceId = null
    function showAudience() {
        audienceId = autGroup.audienceId
        _showAudience = true
    }

    function newAudience() {
        autGroup.audienceId = ''
        audienceId = null
        _showAudience = true
    }

    async function closeAudience() {
        _showAudience = false
        await loadAudiences()
        autGroup.audienceId = audienceId
        audienceOnChange()
    }

    let automationGroupId: string = null
    function showAutomationContacted(_automationGroupId) {
        automationGroupId = _automationGroupId
        step = 4
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Automações'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Ativo', type: GridColTypeEnum.toggle }))
        grid.cols.push(new GridCol({ content: 'Tipo' }))
        grid.cols.push(new GridCol({ content: 'Nome da automação' }))
        grid.cols.push(new GridCol({ content: 'Criação', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Edição', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const toggle = new GridToggle({
                callback: () => {
                    toggleStatus(item.automationGroupId)
                },
                checked: item.status === 100,
            })
            const btnShow = new GridButton({
                callback: () => showAutomationContacted(item.automationGroupId),
                label: 'Ver',
            })

            const btnEdit = new GridButton({
                callback: () => editEntity(item.automationGroupId),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({ content: toggle })
            line.slots.push({ content: friendlySource(item.source as AutomationSourceEnum) })
            line.slots.push({ content: item.label })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.updatedAt })
            line.slots.push({ content: [btnShow, btnEdit] })
            grid.lines.push(line)
        }
    }

    function friendlySource(source: AutomationSourceEnum) {
        if (source === AutomationSourceEnum.automacao_agenda) return 'Automação da Agenda'
        if (source === AutomationSourceEnum.automacao_agenda_2) return 'Automação da Agenda (V2)'
        //if (source === AutomationSourceEnum.automacao_classificacao) return 'Automação de Tageamento'
        if (source === AutomationSourceEnum.automacao_comunicacao) return 'Automação de Comunicação'
        if (source === AutomationSourceEnum.automacao_indica) return 'Automação do Indica'
        if (source === AutomationSourceEnum.automacao_nps) return 'Automação de NPS'
        if (source === AutomationSourceEnum.automacao_pdv) return 'Automação do PDV'
        if (source === AutomationSourceEnum.automacao_pipeline) return 'Automação do Pipeline'
        return 'Automação genérica'
    }

    function audienceOnChange() {
        //if (!autGroup.label) {
        autGroup.label = audiences.find((el) => el.audienceId === autGroup.audienceId)?.title
        //}
    }

    // ---- opções dos campos ------------------------------------------------------------------
    // o Zinput de select não cria opção vazia sozinho, então o "Selecione..." entra na lista
    const sourceOptions = [
        { value: '', label: 'Selecione...' },
        ...Object.values(AutomationSourceEnum).map((s) => ({ value: s, label: friendlySource(s) })),
    ]

    $: audienceOptions = [{ value: '', label: 'Selecione...' }, ...audiences.map((a) => ({ value: a.audienceId, label: a.title }))]

    // botões que moram dentro do campo de público: editar o escolhido e criar um novo
    $: audienceActs = [
        ...(autGroup.audienceId ? [{ callback: showAudience, icon: faEdit, label: null }] : []),
        { callback: newAudience, icon: faPlus, label: null, color: 'green' },
    ] as GridButton[]

    const repeatOptions = [{ value: 60, label: 'Nunca' }, ...Array.from({ length: maxRepeat }, (_, i) => ({ value: i + 1, label: 'Após ' + (i + 1) + '...' }))]

    const factorOptions = [
        { value: factors[factor_hour], label: 'horas' },
        { value: factors[factor_day], label: 'dias' },
        { value: factors[factor_month], label: 'meses' },
        { value: factors[factor_year], label: 'anos' },
    ]

    // a automação da agenda v2 não repete por tempo: ou roda uma vez, ou a cada agendamento
    const agenda2Options = [
        { value: 60, label: 'Uma vez ao entrar no público' },
        { value: 0, label: 'A cada agendamento (mesmo em sequência)' },
    ]
</script>

{#if hidePhone && step === 2}
    <div class="hide-phone"></div>
{/if}

{#if _showAudience}
    <Popover on:close={closeAudience} title="Meus públicos" width="1325px">
        <AudienceManager on:close={closeAudience} source={autGroup.source} form={true} bind:audienceId />
    </Popover>
{/if}

{#if _showCreateChoice}
    <Popover on:close={() => (_showCreateChoice = false)} title="Nova automação" width="620px" padding="16px">
        <div class="escolha">
            <button class="escolha-op" on:click={chooseTemplate}>
                <div class="escolha-titulo">Criar de um template</div>
                <div class="escolha-desc">
                    Escolha um objetivo — lembrar de um horário, trazer cliente de volta, recuperar um orçamento — e a
                    automação sai pronta, com quem vai receber já definido.
                </div>
            </button>
            <button class="escolha-op" on:click={chooseManual}>
                <div class="escolha-titulo">Criar manualmente</div>
                <div class="escolha-desc">
                    Monte do zero, escolhendo o tipo de automação e o público por conta própria.
                </div>
            </button>
        </div>
    </Popover>
{/if}
{#if step === 1}
    <Content footer={true}>
        <Zact>
            <div class="spacer" />
            {#if window.store.token.permissions.marketing.marketing.write}
                <Zbutton color="primary" icon={faPlusCircle} label="Nova automação" on:click={openCreateChoice} />
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid} />
        <LoadSpinner {show} />
    </Content>
{/if}

{#if step === 2}
    <Content footer={true}>
        <Zact>
            <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showEntities} />
            <div class="spacer" />
            {#if autGroup.automationGroupId}
                <Zbutton color="red" icon={faTrashAlt} label="Excluir" on:click={removeEntity} />
            {/if}
            <Zbutton
                color="primary"
                icon={faSave}
                label={autGroup.automationGroupId ? 'Salvar' : 'Salvar e continuar...'}
                disabled={show}
                on:click={saveEntity}
            />
        </Zact>

        <div class="sections">
            <ZsheetSection label="Automação" meta={autGroup.source ? '' : 'obrigatório'}>
                <ZContainer gapRow="8px" gapCol="8px">
                    <!-- o tipo define o gatilho e não muda depois de criada: as ações já foram montadas para ele -->
                    <Zinput
                        size={4}
                        sizeM={12}
                        label="Tipo de automação"
                        type="select"
                        options={sourceOptions}
                        disabled={!!autGroup.automationGroupId}
                        bind:value={autGroup.source}
                    />
                    <Zinput
                        size={6}
                        sizeM={12}
                        label="Público a ser automatizado"
                        type="select"
                        options={audienceOptions}
                        acts={audienceActs}
                        bind:value={autGroup.audienceId}
                        on:change={audienceOnChange}
                    />
                    <Zinput size={2} sizeM={12} type="toggle" label="Ativo" bind:value={active} />
                </ZContainer>
            </ZsheetSection>

            <ZsheetSection label="Automatizar este público">
                <ZContainer gapRow="8px" gapCol="8px">
                    <Zinput size={6} sizeM={12} label="Nome da automação" type="text" bind:value={autGroup.label} />
                    {#if autGroup.source !== AutomationSourceEnum.automacao_agenda_2}
                        <Zinput
                            size={showFactor ? 4 : 6}
                            sizeM={12}
                            label="Repetir para a mesma pessoa"
                            type="select"
                            options={repeatOptions}
                            bind:value={dynamicRepeat}
                            on:change={dinamicoOnChange}
                        />
                        {#if showFactor}
                            <!-- a unidade do prazo só aparece quando há prazo: em "Nunca" não há o que medir -->
                            <Zinput size={2} sizeM={12} label="Unidade" type="select" options={factorOptions} bind:value={dynamicRepeatFactor} />
                        {/if}
                    {:else}
                        <Zinput
                            size={6}
                            sizeM={12}
                            label="Executar automação"
                            type="select"
                            options={agenda2Options}
                            bind:value={dynamicRepeat}
                            on:change={dinamicoOnChange}
                        />
                    {/if}
                </ZContainer>
            </ZsheetSection>

            {#if autGroup.automationGroupId}
                <AutomacaoManagerActs
                    bind:this={childAct}
                    automationGroupId={autGroup.automationGroupId}
                    automationId={childActAutomationId}
                    source={autGroup.source}
                />
            {/if}
        </div>
        <LoadSpinner {show} />
    </Content>
{/if}

{#if step === 3}
    <Content footer={true}>
        <Zact>
            <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showEntities} />
            <div class="spacer" />
        </Zact>
        <div class="grid-body mt-4">
            <DadosEventos source={autGroup.source} />
        </div>
    </Content>
{/if}

{#if step === 5}
    <Content footer={true}>
        <AutomacaoAssistente on:close={showEntities} on:created={assistantCreated} />
    </Content>
{/if}

{#if step === 4}
    <div class="m-bottom-sm">
        <AutomacaoShow on:close={showEntities} {automationGroupId} />
    </div>
{/if}

<style>
    /* escolha do caminho de criação, no popover de "Nova automação" */
    .escolha {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .escolha-op {
        /* button não herda cor: sem isto o texto some no tema escuro */
        color: inherit;
        font: inherit;
        text-align: left;
        padding: 14px 16px;
        border: 1px solid #d5d8dd;
        border-radius: 8px;
        background: #ffffff;
        cursor: pointer;
        transition: border-color 0.15s, background 0.15s;
    }
    .escolha-op:hover {
        border-color: #2f8f63;
        background: #f6fbf8;
    }
    :global(.theme_dark) .escolha-op {
        background: #202020;
        border-color: #3a3a3a;
    }
    :global(.theme_dark) .escolha-op:hover {
        background: #262b27;
        border-color: #2f8f63;
    }
    .escolha-titulo {
        font-weight: 600;
        margin-bottom: 3px;
    }
    .escolha-desc {
        font-size: 0.85rem;
        opacity: 0.7;
        line-height: 1.45;
    }

    /* pilha de blocos: cada assunto num cartão, como nas outras telas modernizadas */
    .sections {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin: 12px 0px 48px 0px;
    }

    .hide-phone {
        position: absolute;
        height: 32px;
        backdrop-filter: blur(6px);
        top: 0px;
        left: 0px;
        width: 100vw;
        z-index: 1000;
    }
</style>
